const realPath = window.location.href.toString().split('/')

export default {
  openProfileCompany: function (cnpj, document, state) {
    if (cnpj) {
      if (cnpj.length >= 14) {
        window.open('http://' + realPath[2] + '/' + cnpj, '_blank')
      } else {
        window.open('http://' + realPath[2] + '/' + document + '/' + state, '_blank')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/links-profile-company/resources/methods.js